// Check the user-agent-platform library README.md for more
// information about the license of this package.
import * as uaParser from "ua-parser-js";

import {
    CHROME_USER_AGENT,
    DocumentEvent,
    QQBROWER_USER_AGENT,
    WECHAT_USER_AGENT,
} from "@hermes/utils-generic-constants";

/**
 * Return true if user agent is wechat
 */
export const isWeChatAgent = (userAgent: string): boolean =>
    userAgent.includes(WECHAT_USER_AGENT);

export const isQQBrowerAgent = (userAgent?: string): boolean =>
    userAgent?.includes(QQBROWER_USER_AGENT) ?? false;

export const isChromeAgent = (userAgent: string): boolean =>
    userAgent?.includes(CHROME_USER_AGENT) ?? false;

export const stopEventPropagation = (event: Event): void => {
    event.stopPropagation();
    event.preventDefault();
};

export const isMobileDevice = (userAgent: string): boolean => {
    const userAgentParser = new uaParser.UAParser(userAgent);
    return userAgentParser.getDevice().type === "mobile";
};

/**
 * Method that encapsulates native method document.addEventListener with safer signature
 * @param document Html document
 * @param documentEvent Document event
 * @param callback function to execute on given event
 */
export const documentAddEventListener = (
    document: Document,
    documentEvent: DocumentEvent,
    callback: (() => void) | ((event: PointerEvent) => void),
): (() => void) => {
    document.addEventListener(documentEvent, callback);

    return () => document.removeEventListener(documentEvent, callback);
};

/**
 * Waits for the next browser paint by awaiting two animation frames.
 *
 * Why two rAFs:
 * - The first `requestAnimationFrame` runs *before* the next repaint.
 * - The second runs on the following frame, which usually means the previous
 * frame had time to layout/paint your DOM/style changes.
 *
 * @returns A promise that resolves after two animation frames.
 */
export const nextPaint = (): Promise<void> =>
    new Promise<void>((resolve) =>
        requestAnimationFrame(() => requestAnimationFrame(() => resolve())),
    );
